/* eslint-disable dot-notation */
import {
    Tools,
    UrlService,
    Cookie,
    ExternalApiService,
    PlatformAPI,
    SolarAPI,
    Dictionary,
    TranslationsAPI,
    SolarGatewayAPI,
    LocalstorageTTLService,
} from '../../../../../functions/asg-framework/js/services';
import { AsgFW } from '../../../../../functions/asg-framework/js/asg-fw';
import {
    AsgApp,
    Player,
    Games,
    InGame,
    Phonegap,
} from '../../../../../functions/asg-framework/js/asg-app';
import { AsgUI } from '../../../../../functions/asg-framework/js/asg-ui';
import { AppUI } from '../js/app.ui';

// services.js
window['Tools'] = Tools;
window['UrlService'] = UrlService;
window['Cookie'] = Cookie;
window['ExternalApiService'] = ExternalApiService;
window['PlatformAPI'] = PlatformAPI;
window['SolarAPI'] = SolarAPI;
window['Dictionary'] = Dictionary;
window['TranslationsAPI'] = TranslationsAPI;
window['SolarGatewayAPI'] = SolarGatewayAPI;
window['LocalstorageTTLService'] = LocalstorageTTLService;

// asg-fw.js
window['AsgFW'] = AsgFW;

// asg-app.js
window['AsgApp'] = AsgApp;
window['Player'] = Player;
window['Games'] = Games;
window['InGame'] = InGame;
window['Phonegap'] = Phonegap;

// asg-ui.js
window['AsgUI'] = AsgUI;
window['AppUI'] = AppUI;
